/* eslint-disable prettier/prettier */
import select2 from "select2";
import {isMobile, MobileBreakpoint} from './MobileUtils';
import FixBody from '../utils/FixBody';


export const Select2Init = (elementToAppend = null, otherOptions = {}) => {
  let options = {
    resolve: 'width',
    minimumResultsForSearch: -1,
    containerCssClass: 'custom-dt-container',
    dropdownCssClass: 'custom-dt-dropdown'
  }
  if (elementToAppend) {
    options.dropdownParent = elementToAppend
  }

  options = {
    ...options,
    ...otherOptions
  }

  $('select:not(#countries-select)').select2(options);
  $('.select2-selection__rendered').removeAttr('title');
  $('select.select2-hidden-accessible').each((index, select)=> {
    if($(select).select2('data').length != 0 && $(select).select2('data')[0].text != ''){
      const targetLabel = $(select).prev('label');
      if(targetLabel.length){
        targetLabel.addClass('selected');
      } else {
        $(select).parent('.select-wrapper').addClass('centered');
      }
    }

    const selectLabel = $(select).prev('label')[0];
    if(selectLabel) {
      if(typeof selectLabel.id === "undefined" || selectLabel.id === '') {
        selectLabel.id = `select-${index}_${Date.now().toString()}`;
      }
      $(select).parent().find('.select2-selection').attr("aria-labelledby",selectLabel.id)
    }
  })
    // OPEN SELECT
  $('select').on('select2:open', (elm) => {


    $('.select2-results__options').css('pointer-events', 'none');
    // DISABLE SELECTION on open mobile
    setTimeout(()=>{
        $('.select2-results__options').css('pointer-events', 'auto');
    },500);

    if($('.modelfitting', '.custom-dt-dropdown').length == 0){
        if($('.sizes-select').hasClass('model-fitting')){
          const modelFitting = $('.sizes-select.model-fitting').data('fitting');
          $('.custom-dt-dropdown:not(.countries-select-dropdown)').append(`<div class="modelfitting">${modelFitting}</div>`);
        }
    }

    if($('.divider', '.custom-dt-dropdown').length == 0){
        $('.custom-dt-dropdown:not(.countries-select-dropdown)').prepend("<span class='divider'></span>");
        if (isMobile(MobileBreakpoint.Max1023)) {
            $('select:not(#countries-select)').each((index,select)  => {
              if($(select).data('placeholder') && $('.mobile-placeholder').length == 0){
                return $('.divider').after("<div class='mobile-placeholder'>" + $(select).data('placeholder') + "</div>")
              } else return;
            })
        //$('.divider').after("<div class='mobile-placeholder'>" + $('select')[0].data('placeholder') + "</div>");
        }
    }
    if (isMobile(MobileBreakpoint.Max1023)) {
      $('body').css('overflow-y', 'hidden');
      $('.vex').css('overflow-y', 'hidden');
      FixBody.block();
      $('.background-select-layer').show();
    }

  });

    // SELECT on CLOSE
    $('select').on('select2:close', (elm) => {
      $('.background-select-layer').hide();
      // REMOVE SELECTED CLASS FOR FLOATING LABEL
      const target = $(elm.target);
      const targetLabel = target.prev('label');
      const targetOptions = $(elm.target.selectedOptions);
      if (targetOptions.length === 0) {
        targetLabel.removeAttr('class');
      }
      if (isMobile(MobileBreakpoint.Max1023)) {
        FixBody.unblock();
        $('body').css('overflow-y', 'auto');
        $('.vex').css('overflow-y', 'auto');
      }
    })
    $('select').on('select2:select', (elm) => {
      // ADD SELECTED CLASS FOR FLOATING LABEL
      const targetLabel = $(elm.target).prev('label');
      targetLabel.addClass('selected');
      // remove title as attribute on rendered selection
      $('.select2-selection__rendered').removeAttr('title');
      $('.select2-results__option').removeAttr('title');
    })

  };
